import { FC } from "react";
import MeasurementUnitWebLayout from "./WebLayout";

const MeasurementUnit: FC = () => {
  return (
    <div>
      <MeasurementUnitWebLayout />
    </div>
  );
};

export default MeasurementUnit;
